import type { ChallengeKind } from '../../api/ownerTypes'

/** Wat er op het scherm staat voor een challengetype (22A, 22B, 22C, 22G). */
export function kindLabel(kind: ChallengeKind): string {
  return kind === 'Photo' ? 'Foto' : kind === 'Video' ? 'Video' : 'Allebei'
}

/**
 * "Meteen" of "Vanaf 21:30" — de kolom "Moment" in 22G.
 *
 * De tijd komt uit de server in UTC en wordt hier lokaal getoond: een feest
 * begint om half tien plaatselijke tijd, niet in UTC.
 */
export function momentLabel(unlocksAtUtc: string | null): string {
  if (!unlocksAtUtc) {
    return 'Meteen'
  }

  return `Vanaf ${new Date(unlocksAtUtc).toLocaleTimeString('nl-BE', {
    hour: '2-digit',
    minute: '2-digit',
  })}`
}

/**
 * Zet een tijd van vandaag ("21:30") om naar een moment op de dag van het
 * feest. Zonder eventdatum vallen we terug op vandaag — dan is het een keuze
 * van de eigenaar op het scherm zelf en niet iets dat wij bedenken.
 */
export function momentToUtc(time: string, eventDateUtc: string | null): string | null {
  if (time === '') {
    return null
  }

  const [hours, minutes] = time.split(':').map(Number)
  const day = eventDateUtc ? new Date(eventDateUtc) : new Date()
  const local = new Date(day.getFullYear(), day.getMonth(), day.getDate(), hours, minutes)

  return local.toISOString()
}

/** De omgekeerde weg, voor het invoerveld. */
export function momentToLocalTime(unlocksAtUtc: string | null): string {
  if (!unlocksAtUtc) {
    return ''
  }

  const at = new Date(unlocksAtUtc)
  const pad = (value: number) => String(value).padStart(2, '0')

  return `${pad(at.getHours())}:${pad(at.getMinutes())}`
}
